import {useState} from "react";
import {debounce} from "lodash";
import axios, {type CancelTokenSource} from "axios";
import {successResponse} from "helpers/map";
import mapXCompanyApi from "api/companyApi";

let cancelToken: CancelTokenSource;

const useCompanySearchService = () => {
	const [loadingCompanies, setLoadingCompanies] = useState<boolean>(false);

	const fetchCompanies = debounce(
		async (inputString: string, callback: (options: Record<string, string>[]) => void) => {
			setLoadingCompanies(true);
			//Check if there are any previous pending requests
			if (typeof cancelToken !== typeof undefined) {
				cancelToken.cancel("Operation canceled due to new request.");
			}

			//Save the cancel token for the current request
			cancelToken = axios.CancelToken.source();

			const config = {cancelToken: cancelToken.token};

			const response = await mapXCompanyApi.getCompanyByName(inputString, config);

			if (response === undefined) {
				setLoadingCompanies(true);
			}

			if (successResponse(response, 200)) {
				setLoadingCompanies(false);

				const data: Record<string, string>[] = response.data.results;

				return callback(data);
			} else {
				setLoadingCompanies(false);

				return callback([]);
			}
		},
		800,
	);

	return {
		loadingCompanies,
		fetchCompanies,
	};
};

export default useCompanySearchService;
